var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/quickshop-actions/quickshop-add-link.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToCart")),"isPending") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToCart")),"isSuccess")) {
output += "<a href=\"#\" class=\"c-product-add-links__a is-pending js-wishlist-add-to-cart\" aria-controls=\"a-cart-confirm\" data-qa-add-to-cart>\n        • • •\n    </a>\n\n";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToCart")),"isSuccess") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToCart")),"isPending")) {
output += "<a href=\"#\" class=\"c-product-add-links__a is-success js-wishlist-add-to-cart\" aria-controls=\"a-cart-confirm\" data-qa-add-to-cart>\n        ";
output += runtime.suppressValue((lineno = 13, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "SLAs")),"addedToCart")])), env.opts.autoescape);
output += "\n    </a>\n\n";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToCart")),"canAddToCart") == false) {
output += "<a href=\"#\" class=\"u-link--disabled is-disabled c-product-add-links__a\" aria-controls=\"a-cart-confirm\" data-qa-add-to-cart>\n        ";
output += runtime.suppressValue((lineno = 20, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "SLAs")),"addToCart")])), env.opts.autoescape);
output += "\n    </a>\n\n";
;
}
else {
output += "<a href=\"#\"\n       class=\"js-wishlist-add-to-cart c-product-add-links__a\"\n       aria-controls=\"a-cart-confirm\"\n       data-qa-add-to-cart\n       data-cm-element=\"add_to_cart\"\n       data-product-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"id"), env.opts.autoescape);
output += "\"\n       data-product-type=\"regular\">\n        ";
output += runtime.suppressValue((lineno = 33, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "SLAs")),"addToCart")])), env.opts.autoescape);
output += "\n    </a>";
;
}
;
}
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/quickshop-actions/quickshop-add-link.j2"] , dependencies)